import { useState, useEffect } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import TextArea from "../ReusableComponents/TextArea";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import Loader from "../ReusableComponents/Loader";
import GridPage from "../components/GridPage";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { complaintsHeader } from "../components/HeaderAttribute";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { BindPostAPI, IUDAPI } from "../services/APIConnection";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import toast from "react-hot-toast";
import ComplaintsPopUp from "../popup-containers/ComplaintsPopUp";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
function Complaints() {
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // format: YYYY-MM-DD
  };
  
  const [formFields, setFormFields] = useState({
    complaintsno: "COM",
    bookingno: "",
    guestname: "",
    description: "",
    complaintdate:getTodayDate(),
    mstRoomId: "",
    roomtype: "",
    complaintstype: "",
    roomList: [],
    bookedperson: "",
    bookingdate: "",
    checkindate:"",
    
    complaints: "",
  });
  const [roomDD, setRoomDD] = useState([]);
  const [roomTypeDD, setRoomTypeDD] = useState([]);
  const handleInputChangeForm = (e, customName) => {
    // Handle native DOM events (e.g., input, select)
    if (e?.target) {
      const { name, value } = e.target;
      setFormFields((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
    // Handle custom dropdowns (e.g., react-select)
    else if (e?.value && customName) {
      setFormFields((prevData) => ({
        ...prevData,
        [customName]: e.value,
      }));
    }
  };

  

  var clientId = sessionStorage.getItem("MstClientId");
  const [errors, setErrors] = useState({});
  const isEmpty = (val) => val === null || val === "" || val === undefined;

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "complaintdate":
        if (isEmpty(value)) error = "Enter Date";
        break;

      case "roomtype":
        if (isEmpty(value)) error = "Select Room Type";
        break;

      case "mstRoomId":
        if (isEmpty(value)) error = "Select Room";
        break;

      case "guestname":
        if (isEmpty(value)) error = "Select Guest Name";
        break;

      case "complaints":
        if (isEmpty(value)) error = "Select Complaints";
        break;

      default:
        break;
    }

    return error;
  };

  const handleBlur = (e, fieldName) => {
    let name, value;

    if (e?.target) {
      // For InputText
      name = e.target.name;
      value = e.target.value;
    } else {
      // For dropdowns (use stored value from formFields)
      name = fieldName;
      value = formFields[fieldName] || "";
    }

    const error = validateField(name, value);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setTxnComplaintsId(bindComplaintsData[rowIndex].TxnComplaintsId);
    let filteredItems = [];
    if (bindComplaintsData[rowIndex].MstRoomTypeId) {
      filteredItems = roomDD
        .filter(
          (item) =>
            item.MstRoomTypeId === bindComplaintsData[rowIndex].MstRoomTypeId
        )
        .map((item) => ({
          value: item.MstRoomMasterID,
          label: item.RoomName,
          // uom: item.UOM, // if needed later
        }));
    }
    setFormFields({
      ...formFields,

      complaintsno: bindComplaintsData[rowIndex].ComplaintsNo,
      description: bindComplaintsData[rowIndex].Description,
      complaintdate: bindComplaintsData[rowIndex].ComplaintsDate.split("T")[0],
      bookedperson: bindComplaintsData[rowIndex].BookedPerson,
      bookingdate: bindComplaintsData[rowIndex].BookingDate.split("T")[0],
      checkindate: bindComplaintsData[rowIndex].CheckinDate.split("T")[0],
      guestname: bindComplaintsData[rowIndex].GuestName,
      complaints: bindComplaintsData[rowIndex].TxnComplaintsTypeId,
      bookingno: bindComplaintsData[rowIndex].BookingNo,
      roomtype: bindComplaintsData[rowIndex].MstRoomTypeId,
      roomList: filteredItems,
      mstRoomId: bindComplaintsData[rowIndex].MstRoomId,
    });
  };
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };
  const [bindComplaintsData, setBindComplaintsData] = useState([]);
  const [complaintsType, setComplaintTypes] = useState([]);
  const [guestNameData, setGuestNameData] = useState([]);
  const [TxnComplaintsId, setTxnComplaintsId] = useState([]);
  var createdBy = sessionStorage.getItem("createdBy");
  useEffect(() => {
    BindGetComplaintRoomDetails();
  }, []);

  const BindGetComplaintRoomDetails = async () => {
    const data1 = {
      mstClientId: clientId,
    };

    const response = await BindPostAPI(
      data1,
      "Complaints/BindGetComplaintRoomDetails"
    );

    console.log("roomdetails:", response);
    if (response && response.data) {
      const RoomTypes = response.data.Table.map((item) => ({
        value: item.MstRoomTypeId,
        label: item.RoomType,
      }));
      setRoomTypeDD(RoomTypes);
      setRoomDD(response.data.Table1);

      const complaintTypes = response.data.Table2.map((item) => ({
        label: item.ComplaintsType,
        value: item.TxnComplaintsTypeId,
      }));
      setComplaintTypes(complaintTypes);
    } else {
      setRoomTypeDD([]);
      setRoomDD([]);
      setComplaintTypes([]);
    }
  };

  useEffect(() => {
    bindComplaintsDatas();
  }, []);

  const bindComplaintsDatas = async (value) => {
    //
    const data = {
      mstClientId: clientId,
    };
    setIsLoading(true);
    const response = await BindPostAPI(data, "Complaints/BindComplaints");

    console.log("Data submitted Complaints:", response);

    if (response && response.data) {
      setBindComplaintsData(response.data.Table);
      setIsLoading(false);
      //console.log(response.data.Table)
    } else {
      setBindComplaintsData([]);
    }
  };

const BindGetComplaintsValuesData = async (roomValue) => {
  const data = {
    mstClientId: clientId,
    complaintsDate: formFields.complaintdate,
    roomType: formFields.roomtype,
    room: roomValue,

  };

  const response = await BindPostAPI(
    data,
    "Complaints/BindGetComplaintsValues"
  );

  console.log("Complaints Response:", response);

  if (response && response.data && response.data.Table?.length > 0) {
    const tableData = response.data.Table[0];

    // Prepare guest dropdown
    const guestArray = (tableData.GuestNames || "")
      .split(",")
      .map((name) => name.trim())
      .filter((name) => name);

    const dropdownOptions = guestArray.map((name) => ({
      value: name,
      label: name,
    }));

    setGuestNameData(dropdownOptions);

    // Update all relevant form fields in one call
    setFormFields((prev) => ({
      ...prev,
      bookedperson: tableData.BookedPerson || null,
      bookingdate: tableData.BookingDate
        ? tableData.BookingDate.split("T")[0]
        : null,
        // checkindate: tableData.CheckInDate   
        // ? tableData.CheckInDate.split("T")[0]
        // : null,
      bookingno: tableData.BookingNo || "",
      mstRoomId: roomValue,
    }));

    // Clear any previous room-related error
    setErrors((prev) => ({
      ...prev,
      noGuestDatas: "",
    }));
  } else {
    // No data returned
    setGuestNameData([]);
    // setComplaintTypes([]);

    setFormFields((prev) => ({
      ...prev,
      bookedperson: null,
      checkindate:null,
      bookingdate: null,
      
      bookingno: "",
      mstRoomId: roomValue,
    }));

    setErrors((prev) => ({
      ...prev,
      noGuestDatas: "This room has no available guest data",
    }));
  }
};



  const handleSubmit = async (rowIndex, flag) => {
    setIsLoading(true);

    // 🔹 Run validation
    const newErrors = {};
    Object.keys(formFields).forEach((field) => {
      const error = validateField(field, formFields[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    setErrors(newErrors);

    // ❌ Stop here if validation failed
    if (Object.keys(newErrors).length > 0) {
      setIsLoading(false);
      setIsOpen(true);
      return;
    }

    try {
      if (flag === 1 || flag === 2) {
        const data = {
          txnComplaintId: parseInt(TxnComplaintsId) || 0,
          mstClientId: parseInt(clientId) || 0,

          complaintsNo: formFields.complaintsno || "COM",
          complaintDate: formFields.complaintdate || "",
          mstRoomTypeId: formFields.roomtype || null,
          mstRoomId: formFields.mstRoomId || null,
          bookingNo: formFields.bookingno || "",
          bookingDate: formFields.bookingdate || "",
          checkinDate: formFields.checkindate ||"",
          bookedPerson: formFields.bookedperson || "",
          guestName: formFields.guestname || "",
          txnComplaintsTypeId: parseInt(formFields.complaints) || 0,
          description: formFields.description || "",
          createdBy: parseInt(createdBy) || 0,
          flag,
        };

        const response = await IUDAPI(data, "Complaints/IUDComplaints");
        console.log("Complaints Insert/Update:", response);

        if (flag === 1) {
          // Add
          if (response?.data?.Table?.[0]?.Result === "S") {
            toast.success("Complaint added successfully ✅", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("Failed to add complaint ❌", {
              duration: 3000,
              position: "top-center",
            });
          }
        } else if (flag === 2) {
          // Update
          if (response?.data?.Table?.[0]?.Result === "M") {
            toast.success("Complaint updated successfully ✅", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            toast.error("Failed to update complaint ❌", {
              duration: 3000,
              position: "top-center",
            });
          }
        }

        setTimeout(cancel, 3000);
      } else if (flag === 3) {
        // Delete
        const data = {
          txnComplaintId: bindComplaintsData[rowIndex]?.TxnComplaintsId,
          createdBy: parseInt(createdBy) || 0,
          flag,
        };

        const response = await IUDAPI(data, "Complaints/IUDComplaints");
        console.log("Complaints Delete:", response);

        if (response?.data?.Table?.[0]?.Result === "D") {
          toast.success("Complaint deleted successfully ✅", {
            duration: 3000,
            position: "top-center",
          });
        } else {
          toast.error("Failed to delete complaint ❌", {
            duration: 3000,
            position: "top-center",
          });
        }

        setTimeout(cancel, 3000);
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      toast.error("Something went wrong 🚨", {
        duration: 3000,
        position: "top-center",
      });
    } 
  };

  const handleFormFieldChange = (selectedOption, fieldName) => {
    const value = selectedOption?.value || "";

    setFormFields((prev) => {
      const updated = {
        ...prev,
        [fieldName]: value,
      };

      // If roomtype changes, update roomList
      if (fieldName === "roomtype") {
        const filteredRooms = roomDD
          .filter((room) => room.MstRoomTypeId == value)
          .map((room) => ({
            value: room.MstRoomMasterID,
            label: room.RoomName,
          }));

        updated.roomList = filteredRooms;
      }

      return updated;
    });

    // ✅ Validate immediately after update
    const error = validateField(fieldName, value);
    setErrors((prev) => ({
      ...prev,
      [fieldName]: error,
    }));
  };

  const [rowIndex, setRowIndex] = useState([]);
  const [complaintsData, setComplaintsData] = useState([]);
  const handleComplaints = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    setComplaintsData(bindComplaintsData[rowIndex]);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
  };

  const cancel = () => {
    bindComplaintsDatas();
    setpopUpOpen(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setTxnComplaintsId(0);
    setIsLoading(false);
    setFormFields({
      ...formFields,
      complaintsno: "COM",
      bookingno: "",
      guestname: "",
      description: "",
      complaintdate: getTodayDate(),
      mstRoomId: "",
      roomtype: "",
      complaintstype: "",
      roomList: [],
      bookedperson: "",
      bookingdate: "",
      complaints: "",
      checkindate:"",
    });
    setErrors({});
  };

  return (
    <MainLayout>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          header={complaintsHeader}
          title={"Complaints"}
          records={bindComplaintsData}
          handleEdit={handleEdit}
          handleAction={handleComplaints}
          showAdd={showAdd}
          blockview={true}
        />
      )}

      {visibleAdd && (
        <>
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="Complaints"
          />
          <div className={"md:grid gap-4 mb-2 md:grid-cols-4 sm:col-span-1 w-full"}>
            <InputText
              title="Complaints No"
              inputType="text"
              disabled={true}
              name="complaintsno"
              content={formFields.complaintsno}
              controlFunc={handleInputChangeForm}
            />


<InputText
              inputType="date"
              title=" Complaint Date"
              name="complaintdate"
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              content={formFields.complaintdate}
              placeholder="Enter Date"
              disabled={true}
              // tabIndex="9"
              isRequired={true}
              errorMessage={errors.complaintdate}
              classStar="text-red-500"
            />
            <InputText
              inputType="date"
              title=" Check-in Date"
              name="checkindate"
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              content={formFields.checkindate}
              placeholder="Enter Date"
              disabled={false}
              // tabIndex="9"
              isRequired={true}
              errorMessage={errors.complaintdate}
              classStar="text-red-500"
            />
            <AutoDropDown
              name="roomtype"
              title="Room Type"
              errorMessage={errors.roomtype}
              options={roomTypeDD}
              selectedOption={roomTypeDD.find(
                (option) => option.value === formFields.roomtype
              )}
              placeholder="Select"
              Class="custom-class"
              controlFunc={(selectedOption) =>
                handleFormFieldChange(selectedOption, "roomtype")
              }
              controlFuncBlur={() => handleBlur(null, "roomtype")} // 👈 force field name
              classStar="text-red-500"
            />

            <AutoDropDown
              name="mstRoomId"
              title="Room"
              errorMessage={errors.mstRoomId}
              options={formFields.roomList || []}
              selectedOption={formFields.roomList?.find(
                (option) => option.value == formFields.mstRoomId
              )}
              placeholder="Select"
              Class="custom-class"
              controlFunc={(selectedOption) => {
                handleFormFieldChange(selectedOption, "mstRoomId");
                BindGetComplaintsValuesData(selectedOption?.value);
              }}
              controlFuncBlur={() => handleBlur(null, "mstRoomId")} // 👈 force field name
              classStar="text-red-500"
            />
              <InputText
              title="Booking No"
              inputType="text"
              disabled={true}
              content={formFields.bookingno}
              name="bookingno"
              // content={formFields.bookingno}
              controlFunc={handleInputChangeForm}
            />
            <InputText
              title="Booked Person"
              inputType="text"
              disabled={true}
              content={formFields.bookedperson}
              name="bookedperson"
              // content={formFields.bookingno}
              controlFunc={handleInputChangeForm}
            />

            <InputText
              inputType="date"
              title="Booking Date"
              name="bookingdate"
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              content={formFields.bookingdate}
              placeholder="Enter Date"
              disabled={true}
              // tabIndex="9"
              isRequired={true}
              errorMessage={errors.bookingdate}
            />

{/* <InputText
              inputType="date"
              title="Check-in Date"
              name="checkindate"
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              content={formFields.checkindate}
              placeholder="Enter Date"
              disabled={true}
              // tabIndex="9"
              isRequired={true}
              errorMessage={errors.checkindate}
            /> */}
            <DropDown
              name="guestname"
              title="Guest Name"
              type={"select-one"}
              options={guestNameData}
              content={formFields.guestname}
              selectedOption={formFields.guestname}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              placeholder="Select Guest Name"
              // tabIndex="12"
              isRequired={true}
              classStar="text-red-500"
              errorMessage={errors.guestname}
            />

            <DropDown
              name="complaints"
              title="Complaints"
              type={"select-one"}
         
              options={complaintsType}
              selectedOption={formFields.complaints}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              placeholder="Select Complaints Type"
              // tabIndex="12"
              isRequired={true}
              classStar="text-red-500"
              errorMessage={errors.complaints}
            />
    
       </div>
          {errors.noGuestDatas && (
  <span className="text-red-500 font-medium text-sm">{errors.noGuestDatas}</span>
)}
   <div className="mt-4">
            <TextArea
              inputType="text"
              title="Description"
              name="description"
              rows="4"
              maxlength={500}
              content={formFields.description}
              placeholder="Enter Description"
              controlFunc={handleInputChangeForm}
            />
          </div>
          
          <div className="flex justify-center mt-24">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              disabledBtn={false}
              viewSaveButton={false}
              handleSubmit={handleSubmit}
              cancel={cancel}
            />
          </div>
        </>
      )}
          {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
              
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleComplaints}
      >
        <div>
          <PopUpScreenTitle
            title="Complaints"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ComplaintsPopUp data={complaintsData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
          rowIndex={rowIndex}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
}

export default Complaints;
